export const SET_SIMULATIONS = 'simulation/SET_SIMULATIONS';
export const SET_SIMULATION = 'simulation/SET_SIMULATION';
export const ADDING_SIMULATION = 'simulation/ADD_SIMULATION';
export const GETTING_STANDARD_DEVIATIONS = 'simulations/GETTING_STANDARD_DEVIATIONS';